module.exports = __webpack_public_path__ + "img/pr-2.998aefc2.png";